import * as React from 'react';

const ExclamationCircleFilled32 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 32 32", width: 32, height: 32, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16m.764-23.996v11.548h-1.498V8.004zm-1.98 14.763a1.224 1.224 0 1 1 2.45 0 1.224 1.224 0 1 1-2.45 0"
  }
));
ExclamationCircleFilled32.Size = 32;
ExclamationCircleFilled32.Title = "ExclamationCircleFilled";

export { ExclamationCircleFilled32 as default };
